import { MODULE_SPECIFIER_PATTERN } from '@cli-constants/patterns.js'
import { isExternalModuleSpecifier } from './is-external-module-specifier.js'

export function protectExternalModuleSpecifiers(content: string): {
  content: string
  restore: (value: string) => string
} {
  const replacements: Array<[string, string]> = []

  const protectedContent = content.replace(
    MODULE_SPECIFIER_PATTERN,
    (match, prefix: string, quote: string, specifier: string) => {
      if (!isExternalModuleSpecifier(specifier)) {
        return match
      }

      const token = `__BETTERSTART_EXTERNAL_MODULE_${replacements.length}__`
      replacements.push([token, specifier])
      return `${prefix}${quote}${token}${quote}`
    }
  )

  return {
    content: protectedContent,
    restore(value: string): string {
      let restored = value
      for (const [token, specifier] of replacements) {
        restored = restored.replaceAll(token, specifier)
      }
      return restored
    }
  }
}
